import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  href?: string;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  href
}: CTAButtonProps) {
  const baseClasses = `inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-navy-dark bg-gold-button rounded-sm shadow-lg hover:bg-gold-hover transition-colors duration-300 ${className}`;
  const content = <>
      {children}
      <ArrowRight className="ml-2 w-5 h-5" data-id="element-14" />
    </>;
  if (href) {
    const isExternal = href.startsWith('http');
    return <motion.a href={href} onClick={onClick} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} className={baseClasses} whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} data-id="element-15">
        {content}
      </motion.a>;
  }
  return <motion.button onClick={onClick} className={baseClasses} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} data-id="element-16">
      {content}
    </motion.button>;
}